import * as React from "react";
import { Article } from "../shared/article";

export const Heading2 = ({ id, children }) => (
    <h2 className="w-destination-header font-destination-header relative m-auto mb-6 mt-10">
        <a id={id} className="absolute top-[-100px] md:top-[-120px]"></a>
        {children}
    </h2>
);

export const Heading3 = ({ children }) => (
    <h3 className="w-destination-header font-subheader relative m-auto mb-4 mt-6">
        {children}
    </h3>
);
export const Text = ({ children }) =>
    !children || !children.length ? null : <Article>{children}</Article>;
